const ALL_CONSTANTS = {
  PAGE_ROUTES: {
    DEFAULT: "/",
    OP_LANDING: "/operator-landing",
    SUPERVISOR_LANDING: "/supervisor-landing",
    SUPERVISOR_TOTE_INFO: "/supervisor/tote-info/:id",
    SUPERVISOR_TROLLEY_INFO: "/supervisor/trolley-info/:id",
    TOTE_INFO: "/tote-info/:id",
    TROLLEY_INFO: "/trolley-info/:id",
    LOCATION_INFO: "/location-info/:locationId",
    REGISTER_TROLLEY_ERROR: "/register-trolley-error",
    REGISTER_TROLLEY_REVIEW: "/register-trolley-review",
    REGISTER_TOTE_ERROR: "/register-tote-error",
    REGISTER_TOTE_REVIEW: "/register-tote-review",
    TROLLEY_LOCATION_WARNING: "/trolley-location-warning",
  },
  USER_ROlES: {
    OPERATOR: "Operator",
    SUPERVISOR: "Supervisor",
  },

  HTTP_REQUEST_METHODS: {
    POST: "POST",
    GET: "GET",
    DELETE: "DELETE",
    PATCH: "PATCH",
    PUT: "PUT",
  },

  ERROR_PAGE: {
    NOT_FOUND: "pageNotFound",
    NO_AUTH: "notAuthenticated",
    NO_ACCESS: "noAccessToPage",
    COMP_ERROR: "componentError",
    SERVER_ERROR: "serverError",
    HOME: "/",
    LOGIN: "/login",
  },

  HTTP_STATUS: {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORISED: 401,
    FORBIDDEN: 403,
    METHOD_NOT_FOUND: 404,
    METHOD_NOT_ALLOWED: 405,
    UNPROCESSABLE: 422,
    INTERNAL_SERVER_ERROR: 500,
    NOT_IMPLEMENTED: 501,
  },

  HTTP_REQ_DEFAULT_HEADERS: {
    Accept: "application/json",
    "Content-Type": "application/json; charset=UTF-8",
  },

  HTTP_MULTIPART_FORM_HEADERS: {
    "Content-Type": "multipart/form-data",
  },

  API_TIME_OUT: 300000,

  API_ERROR_MSG: "Internal Server Error",
};

const CONSTANTS = Object.freeze(ALL_CONSTANTS);

export default CONSTANTS;
